import React, { memo } from 'react';
import { Button } from '@oscar/theme';
import { Request } from '@oscar/request';
import { APIS } from 'common/constants/endpoints';
import FormList from '../FormList';
import CreateForm from './CreateForm';
import ListItem from './ListItem';
import './style.scss';

const NotificationItem = (item: FileType) => {
  return (
    <div className="file-item">
      <div className="file-item-id">{item.id}</div>
      <div className="file-item-name">{item.id}</div>
      <div className="file-item-action">
        <Button></Button>
      </div>
    </div>
  );
};

interface Props {
  name: string | string[];
  request: Request;
  title: string;
  readOnly?: boolean;
  keyField?: string;
}

export interface FileType {
  id: string;
  fileName: string;
  url: string;
  size: string;
  createdDate: string;
  createdBy: string;
  modifiedDate: string;
  modifiedBy: number;
}

export default memo(function index({
  title,
  name,
  request,
  readOnly,
  keyField = 'fileName',
}: Props) {
  return (
    <div className="file-uploaded">
      <FormList<FileType>
        keyField={keyField}
        title={title}
        name={name}
        childProps={{ request }}
        autoResize
        detailComponent={!readOnly ? CreateForm : undefined}
        listComponent={ListItem}
        onItemRenderer={NotificationItem}
        addedComponent={!readOnly ? CreateForm : undefined}
        readOnly={readOnly}
        fixedWidth="50%"
      />
    </div>
  );
});
